import { LanguageInfo } from "./LanguageInfo";

import { franc } from "franc";
// @ts-ignore
import languageFormatConversion from "iso-639-3-to-1";

import languages from "iso-639-1";

/** detects the language of the text */
export class LanguageDetector{
  detectLanguage(input:string):LanguageInfo|null{
    
  console.log(`detecting from: ${input}`);
  const detected = franc(input, { minLength: 1 });
  console.log(`detected : ${detected}`);
  if (!detected) return null
  const languageCode = languageFormatConversion(detected);
  console.log(`detected 2 : ${languageCode}`);
  const languageName = languages.getName(languageCode);
  return {
    code: languageCode,
    name: languageName,
  };
  }
}
